import React, { useState } from 'react'
import { withFirebase } from '../firebase';
import EliminationForm from './Form/EliminationForm';
import WorldCupForm from './Form/WorldCupForm';
import LeagueForm from './Form/LeagueForm';
import MatchesList from './MatchesList/MatchesList'
import ModalInfo from '../useful/ModalInfo';

const Matches = (props) => {

    const { loading, tournament } = props;

    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    if (loading)
        return (
            <div className="nav justify-content-center pt-2">
                <small>Cargando...</small>
            </div>
        )

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    let component = null;

    if (!tournament.matchesGenerated) {

        if (tournament.type === 'worldCup')
            component = <WorldCupForm {...props} showModal={showModal} />
        else if (tournament.type === 'elimination')
            component = <EliminationForm {...props} showModal={showModal} />
        else
            component = <LeagueForm {...props} showModal={showModal} />

    } else {
        component = <MatchesList {...props} />
    }

    return (
        <div className="" >
            {component}

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />
        </div>
    );
}

export default withFirebase(Matches);